import { useMock, corporateGet } from './client';
import dashboardMock from '@/mocks/corporate/dashboard';

/**
 * Em modo API: retorna apenas o que o backend envia (sem preencher ranking/setores
 * com mock). Em modo Mock: usa o store dinâmico local.
 */
export default {
    async getOverview(accessToken) {
        if (useMock()) return dashboardMock.getOverview();
        return corporateGet('/corporate/dashboard', accessToken);
    },
};
